package ir.hosen.resume.util

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.px

@OptIn(DelicateApi::class)
@Composable
fun Int.bps(): CSSSizeValue<CSSUnit.px> {
    val bp = rememberBreakpoint()

    return if (bp == Breakpoint.ZERO)
        (this / 2).px
    else if (bp <= Breakpoint.SM)
        (this / 1.8).px
    else
        this.px
}